import $ from 'jquery'

export default function ActText(){
}

let win = window.top || window;

ActText.prototype.getText = function (data,type,callback) {
    this.callback = callback;
    let content = "<div class=\"layui-card\">\n" +
        "          <div class=\"layui-card-header\">备注</div>\n" +
        "          <div class=\"layui-card-body layui-row\">\n" +
        "            <div class=\"layui-col-md12\">\n" +
        "              <textarea name=\"\" placeholder=\"请输入备注\" id=\"actText\" name=\"actText\" class=\"layui-textarea\"></textarea>\n" +
        "            </div>\n" +
        "          </div>\n" +
        "        </div>"

    win.layer.open({
            content : content,
            type : 1,
            btn: ['确定','取消']
            ,area: '500px'
            ,cancel: function(index, layero){
                win.layer.close(index);
                win.layer.closeAll("loading");
                return false;
            },end: function(){
                win.layer.closeAll("loading");
                return false;
            }
            ,yes : function(index){
                let value = $("#actText").val();
                let valueLength = value.replace(/\ +/g, ""); //去掉空格
                valueLength = valueLength.replace(/[ ]/g, "");    //去掉空格
                valueLength = valueLength.replace(/[\r\n]/g, ""); //去掉回车换行
                if(valueLength.length < 1){
                    win.layer.msg("请填写备注!",{icon: 2})
                    return false;
                }else if(value.length > 100){
                    win.layer.msg("备注请勿超过100字!",{icon: 2})
                    return false;
                }else{
                    let callbackValue ={};
                    if(type == "activitiUsers" || type == "users"){
                        callbackValue.activitiUsers =value;
                    }else if(type == "remarks"){
                        callbackValue.remarks =value;
                    }
                    callbackValue.type = type;
                    callback(callbackValue);
                    win.layer.close(index);
                }
            },btn2 : function(index, layero){
                win.layer.close(index);
                win.layer.closeAll("loading");
                return false;
            }
        })

};
